import { Alert } from 'components/common';
import { useUserManager } from 'components/hooks';
import { ROUTES } from 'consts';
import withRequest from 'hoc/withRequest';
import React, { useEffect} from 'react'
import { useHistory, withRouter } from 'react-router-dom';
import UserFormDumb from './UserFormDumb';

const UserCreateSmart = () => {

  const history = useHistory();
  const { cleanUpMessage, error, success, postUser } = useUserManager();

  const defaultValues = {
    username: '',
    firstname: '',
    surname: '',
    email: '',
    password: '',
    active: true,
    admin: false,
    roles: [],
    role: ''
  }

  const handleCloseAlert = () => cleanUpMessage();

  const handleCreate = (data) => {
    postUser({
      body: {...data},
    });
  };

  useEffect(() => {
    if (!!success.post) history.push(ROUTES.USER_LIST);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.post]);

  return (
    <>
      <UserFormDumb
        defaultValues={defaultValues}
        handleOnSubmit={handleCreate}
        isEdit={false}
      />

      <Alert
        severity="error"
        handleClose={handleCloseAlert}
        open={error.post}
        message="common.errors.general.title"
      />
    </>
  )
}

export default withRequest(withRouter(UserCreateSmart));
